var map = {
	"./1.3.0": 34882,
	"./1.3.0/": 34882,
	"./1.3.0/CrossChainDispatcher": 59434,
	"./1.3.0/CrossChainDispatcher.json": 59434,
	"./1.3.0/DebtToken": 29003,
	"./1.3.0/DebtToken.json": 29003,
	"./1.3.0/DepositToken": 96204,
	"./1.3.0/DepositToken.json": 96204,
	"./1.3.0/FeeProvider": 53648,
	"./1.3.0/FeeProvider.json": 53648,
	"./1.3.0/NativeTokenGateway": 33317,
	"./1.3.0/NativeTokenGateway.json": 33317,
	"./1.3.0/Pool": 83459,
	"./1.3.0/Pool.json": 83459,
	"./1.3.0/PoolRegistry": 51158,
	"./1.3.0/PoolRegistry.json": 51158,
	"./1.3.0/Quoter": 41281,
	"./1.3.0/Quoter.json": 41281,
	"./1.3.0/SmartFarmingManager": 8036,
	"./1.3.0/SmartFarmingManager.json": 8036,
	"./1.3.0/SyntheticToken": 74388,
	"./1.3.0/SyntheticToken.json": 74388,
	"./1.3.0/index": 34882,
	"./1.3.0/index.js": 34882,
	"./LayerZeroCustomEvents": 36473,
	"./LayerZeroCustomEvents.json": 36473,
	"./MerkleV2Abi": 22016,
	"./MerkleV2Abi.json": 22016,
	"./StargateComposer": 32928,
	"./StargateComposer.json": 32928,
	"./StargateFactory": 77505,
	"./StargateFactory.json": 77505,
	"./StargatePool": 89692,
	"./StargatePool.json": 89692
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 57088;